'use strict';
import { createAction } from 'redux-actions';

const AMT_OPERATIONS_STATUS = 'AMT_OPERATIONS_STATUS';

export const amtOperationsStatus = createAction(AMT_OPERATIONS_STATUS);
